import '@/assets/css/app.scss'
import initDirectives from '@/directives'
import initSentry from '@/plugins/sentry'
import router from '@/router/index'
import store from '@/store/index'
import { i18n } from '@/translation/i18n'
import '@/plugins/veevalidate'
import { createApp, h } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { createPinia } from 'pinia'
import { gtm } from '@/plugins/gtm'

const pinia = createPinia()

const app = createApp({
  render: () => h(App)
})

initSentry(app, router)

app.use(vuetify)
app.use(store)
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(gtm(router))
initDirectives(app)

app.config.performance = import.meta.env.VITE_DEVTOOLS === 'true'

app.mount('#app')
